import { useNavigate, useLocation } from 'react-router-dom'
import { useWorkspace } from '../../../../../contexts/WorkspaceContext.tsx'
import { useAppDispatch } from '../../../../../store/hooks.ts'
import { setMobileSidebarOpen } from '../../../../../store/ui/uiSlice.ts'
import ProjectsIcon from '../../../../../assets/icons/icon-projects.svg?react'
import SidebarUiButton from '../SidebarUiButton/SidebarUiButton.tsx'
import Tooltip from '@/components/ui/Tooltip/Tooltip'

const SidebarProjectsButton = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const { workspace } = useWorkspace()

    const isActive = workspace && location.pathname.startsWith(`/${workspace.workspaceUrlId}/project`)

    const handleClick = () => {
        if (workspace) {
            navigate(`/${workspace.workspaceUrlId}/projects`)
            dispatch(setMobileSidebarOpen(false))
        }
    }

    return (
        <Tooltip title="Projects">
            <SidebarUiButton icon={<ProjectsIcon />} title="Projects" isActive={!!isActive} onClick={handleClick} />
        </Tooltip>
    )
}

export default SidebarProjectsButton
